export default "__VITE_ASSET__CUDNwzVK__"